var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeHeader'),_c('HomeWhyUs'),_c('HomeServices'),_c('HomeMoreInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }